/* eslint-disable func-names */
import { takeEvery, put, call } from "redux-saga/effects";
import "whatwg-fetch";
import * as GlobalActions from "../../actions";
import * as Actions from "./store/actions";
import ActionTypes from "../../constants";
import * as Apis from "./apis";
import { wrapByLoader } from "../../utils";

const searchBP = (action: Actions.SearchBPActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(Apis.searchBPApi, action.payload);
      if (!response.error) {
        const bpList = response.data.businessPartner;
        const paginationInfo = response.data.pageInfo;
        // const searchQuery = action.payload.genericSearch;
        yield put(Actions.searchBPSucceeded(bpList,  paginationInfo));
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

export default [
  takeEvery(ActionTypes.SEARCH_BP, searchBP),
];
